
import { useState } from 'react';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-teal-50 to-cyan-100">
      {/* Navigation */}
      <nav className="bg-white/80 backdrop-blur-md border-b border-teal-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/79cc7bd70f6d7cb5ba573af22dbfb8e5.png"
                alt="AI AM Logo"
                className="h-10 w-auto cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              />
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="#about" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                  AI AMとは
                </a>
                <a href="#services" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                  サービス
                </a>
                <a href="#process" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                  制作の流れ
                </a>
                <a href="#contact-form" className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  お問い合わせ
                </a>
              </div>
            </div>
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-teal-600 p-2"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-teal-100">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#about" className="block px-3 py-2 text-gray-700 hover:text-teal-600 cursor-pointer">
                AI AMとは
              </a>
              <a href="#services" className="block px-3 py-2 text-gray-700 hover:text-teal-600 cursor-pointer">
                サービス
              </a>
              <a href="#process" className="block px-3 py-2 text-gray-700 hover:text-teal-600 cursor-pointer">
                制作の流れ
              </a>
              <a href="#contact-form" className="block px-3 py-2 text-teal-600 font-medium cursor-pointer">
                お問い合わせ
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/b6d57546c64e5ca395e344abb2cb617c.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/70 via-cyan-900/50 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              つくる、考える、伝える。<br />
              <span className="bg-gradient-to-r from-yellow-300 to-orange-300 bg-clip-text text-transparent">
                すべてをAIで。
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-teal-100 mb-8 font-light">
              AIが、あなたのマーケティングチームになる。
            </p>
            <button
              onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              無料でAI映像を制作する
            </button>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">AI AMとは？</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mx-auto mb-8"></div>
          </div>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/845c169ec928821da820f568639d840a.jpeg"
                alt="AI AM Technology"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6">
                  AIが貴社の想いを伝える力になる。
                </h3>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  AI AM(アイ アム)は、生成AIツールを活用してブランドストーリーを感情豊かに、そして精密に企画・制作・配信する、オールインワンAIマーケティングソリューションです。
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  ChatGPT(コピーライティング・戦略)、Sora 2 &amp; Veo 3(映像制作)、Suno(音楽生成)、Filmora(映像編集)、Readdy(ウェブサイト制作)を統合し、企業が迅速かつ美しく、コスト効率の高いマーケティングコンテンツを制作できるようにします。
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm">Veo3</span>
                  <span className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Suno</span>
                  <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm">ChatGPT</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Now / Comparison Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              なぜ今AIマーケティングなのか？
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mx-auto mb-8"></div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-lg font-semibold">項目</th>
                    <th className="px-6 py-4 text-center text-lg font-semibold">従来型代理店</th>
                    <th className="px-6 py-4 text-center text-lg font-semibold">AI AM</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900">映像制作</td>
                    <td className="px-6 py-4 text-center text-red-600 font-semibold">約50〜100万円</td>
                    <td className="px-6 py-4 text-center text-green-600 font-semibold">～約10万円（AI生成）</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900">納期</td>
                    <td className="px-6 py-4 text-center text-red-600 font-semibold">3〜4週間</td>
                    <td className="px-6 py-4 text-center text-green-600 font-semibold">3〜5日</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900">修正対応</td>
                    <td className="px-6 py-4 text-center text-orange-600 font-semibold">都度人力</td>
                    <td className="px-6 py-4 text-center text-green-600 font-semibold">AIによる自動調整</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 font-medium text-gray-900">付加価値</td>
                    <td className="px-6 py-4 text-center text-teal-600 font-semibold">人の感性</td>
                    <td className="px-6 py-4 text-center text-cyan-600 font-semibold">AI＋人の統合感性</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              AI AMができること
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mx-auto mb-8"></div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-video-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">AIプロモーション映像制作</h3>
              <p className="text-gray-700 mb-4">
                ChatGPT + Sora2 + Sunoを活用した高品質なプロモーション映像を短期間で制作
              </p>
              <div className="text-sm text-teal-600 font-medium">ChatGPT • Sora2 • Suno</div>
            </div>
            <div className="bg-gradient-to-br from-emerald-50 to-green-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-600 to-green-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-advertisement-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">AI広告運用</h3>
              <p className="text-gray-700 mb-4">
                P-MAX / AEO対応の自動化された広告最適化システム
              </p>
              <div className="text-sm text-emerald-600 font-medium">P-MAX • AEO対応</div>
            </div>
            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-global-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">LP / サイト自動構築</h3>
              <p className="text-gray-700 mb-4">
                Reddy + ChatGPTによる効果的なランディングページとウェブサイトの自動生成
              </p>
              <div className="text-sm text-cyan-600 font-medium">Readdy • ChatGPT</div>
            </div>
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-music-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">AIサウンドブランディング</h3>
              <p className="text-gray-700 mb-4">
                Sunoを活用した企業サウンドアイデンティティの構築
              </p>
              <div className="text-sm text-indigo-600 font-medium">Suno</div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">制作事例</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              AIを活用して制作した実際の映像作品をご紹介します。<br />
              様々な業界・用途に対応した高品質な映像制作が可能です。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Case Study 2 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative aspect-video cursor-pointer" onClick={() => window.open('https://youtu.be/rSXAUyNc3As', '_blank')}>
                <img
                  src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/19e37bddedb4fad26476c792e517eac5.jpeg"
                  alt="企業PR動画"
                  className="w-full h-full object-cover rounded-t-2xl"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center hover:bg-black/30 transition-colors">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-3xl text-gray-800 ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  企業PR動画<br />
                  (アサギ株式会社 様)
                </h3>
                <p className="text-gray-600 mb-4 text-center">
                  女性が布団で眠るシーンはAIモデルを使用。社名入りAI音楽を活用し、記憶に残りやすい企業PR映像へと演出。
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm">Veo3</span>
                  <span className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">Suno</span>
                  <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm">Filmora</span>
                </div>
              </div>
            </div>

            {/* Case Study 1 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative aspect-video cursor-pointer" onClick={() => window.open('https://youtu.be/hEtuoV7XIU4', '_blank')}>
                <img
                  src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/b8a5af8577c58bcd98399e3b573309d5.jpeg"
                  alt="AI映像制作事例"
                  className="w-full h-full object-cover rounded-t-2xl"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center hover:bg-black/30 transition-colors">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-3xl text-gray-800 ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  ホテルプロモーション動画<br />
                  (伊良湖ホテル&amp;リゾート 様)
                </h3>
                <p className="text-gray-600 mb-4 text-center">
                  実在する客室映像にAIモデルを組み合わせ、ホテル滞在のひとときを表現。モデル起用なしで、体験価値を映像で伝えるプロモーションムービーを制作。
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-200 text-teal-800 px-3 py-1 rounded-full text-sm">Veo3</span>
                  <span className="bg-cyan-200 text-cyan-800 px-3 py-1 rounded-full text-sm">Suno</span>
                  <span className="bg-emerald-200 text-emerald-800 px-3 py-1 rounded-full text-sm">Filmora</span>
                </div>
              </div>
            </div>

            {/* Case Study 3 */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
              <div className="relative aspect-video cursor-pointer" onClick={() => window.open('https://youtube.com/shorts/0nwCrXhQJec', '_blank')}>
                <img
                  src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/57cdc4ce173fb9c93f409648747fef69.jpeg"
                  alt="アニメーション動画"
                  className="w-full h-full object-cover rounded-t-2xl"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center hover:bg-black/30 transition-colors">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-3xl text-gray-800 ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  SNS用アニメーション動画<br />
                  (株式会社アンデージ 様)
                </h3>
                <p className="text-gray-600 mb-4 text-center">
                  AI技術を活用して制作したアニメーション映像。独自の世界観と映像表現が低予算で制作可能。
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm">Sora2</span>
                  <span className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">ChatGPT</span>
                  <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm">Filmora</span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-gray-600 mb-6">
              あなたの企業も、このような高品質なAI映像を制作できます
            </p>
            <button
              onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              無料でAI映像を制作する
            </button>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="process" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">制作の流れ</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mx-auto mb-8"></div>
          </div>
          <div className="grid md:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">申込みフォーム入力</h3>
              <p className="text-gray-600 text-sm">企業情報とご要望をお聞かせください</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-emerald-600 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                お打ち合わせ<br />
                ＋ChatGPTによる構成
              </h3>
              <p className="text-gray-600 text-sm">AIが最適な映像構成を提案します</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">AI(Sora/Veo/Klingなど）で映像生成</h3>
              <p className="text-gray-600 text-sm">最新AIで高品質映像を生成</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Sunoで音楽生成<br />
                ＋Filmora編集
              </h3>
              <p className="text-gray-600 text-sm">オリジナル音楽と映像編集</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">5</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">動画納品＆AIマーケ相談</h3>
              <p className="text-gray-600 text-sm">完成動画の納品と今後の相談</p>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Single%20person%20receiving%20AI%20support%20for%20content%20creation%20and%20information%20sharing%2C%20one%20individual%20working%20with%20AI%20assistant%20for%20digital%20communication%2C%20person%20using%20AI%20technology%20for%20social%20media%20and%20content%20publishing%2C%20warm%20professional%20lighting%2C%20modern%20workspace%20with%20holographic%20AI%20interface%20helping%20with%20writing%20and%20content%20strategy%2C%20human-AI%20collaboration%20for%20information%20dissemination%2C%20teal%20and%20cyan%20color%20scheme&width=600&height=400&seq=ai-support-single-person&orientation=landscape"
                alt="AI Information Support"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">AI AMの想い</h2>
              <div className="w-24 h-1 bg-gradient-to-r from-teal-600 to-cyan-600 mb-8"></div>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                AIは人を置き換えるものではありません。AIは人の創造性を拡張し、より豊かな表現が可能にするパートナーです。
              </p>
              <blockquote className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 italic border-l-4 border-teal-600 pl-6">
                「AIが人の表現を拡張する。」
              </blockquote>
              <p className="text-lg text-gray-700 leading-relaxed">
                私たちは、テクノロジーと人間の感性を融合させ、これまでにない創造的なマーケティング体験を提供します。あなたの想いを、AIの力で世界に届けましょう。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">
            あなたの企業も、AIマーケティングを体験してみませんか？
          </h2>
          <p className="text-xl mb-8 opacity-90">
            今すぐ無料でAI映像制作を体験し、新しいマーケティングの可能性を発見してください。
          </p>
          <a
            href="#contact-form"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors duration-300 inline-block whitespace-nowrap cursor-pointer"
          >
            無料でAI映像を制作する
          </a>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-2">お問い合わせ</h2>
            <p className="text-xl text-gray-600 mb-4">(AI映像制作依頼)</p>
            <p className="text-lg text-gray-600">
              無料でAI映像制作を体験してみませんか？下記フォームよりお気軽にお問い合わせください。
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8">
            <form
              id="ai-video-inquiry-form"
              data-readdy-form
              className="space-y-6"
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                const data = new URLSearchParams();

                // Convert FormData to URLSearchParams
                for (const [key, value] of formData.entries()) {
                  if (typeof value === 'string') {
                    data.append(key, value);
                  }
                }

                // Validate required fields
                const requiredFields = ['company_name', 'contact_name', 'email', 'phone', 'video_purpose'];
                const missingFields = requiredFields.filter((field) => !data.get(field));

                if (missingFields.length > 0) {
                  alert('必須項目を入力してください: ' + missingFields.join(', '));
                  return;
                }

                // Validate email format
                const email = data.get('email');
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s-]+$/;
                if (email && !emailRegex.test(email)) {
                  alert('正しいメールアドレスを入力してください。');
                  return;
                }

                // Validate textarea length
                const videoImage = data.get('video_image');
                if (videoImage && videoImage.length > 500) {
                  alert('動画イメージは500文字以内で入力してください。');
                  return;
                }

                const other = data.get('other');
                if (other && other.length > 500) {
                  alert('その他は500文字以内で入力してください。');
                  return;
                }

                // Submit form
                fetch('https://readdy.ai/api/form/d4a02vqv5c5frdsvkkag', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: data.toString(),
                })
                  .then((response) => {
                    if (response.ok) {
                      alert('お問い合わせありがとうございます。3営業日以内にご連絡いたします。');
                      (e.target as HTMLFormElement).reset();
                    } else {
                      alert('送信に失敗しました。もう一度お試しください。');
                    }
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                    alert('送信に失敗しました。もう一度お試しください。');
                  });
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="company_name" className="block text-sm font-medium text-gray-700 mb-2">
                    会社名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="company_name"
                    name="company_name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="株式会社○○○"
                  />
                </div>

                <div>
                  <label htmlFor="contact_name" className="block text-sm font-medium text-gray-700 mb-2">
                    ご担当者名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact_name"
                    name="contact_name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="山田 太郎"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    メールアドレス <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="example@company.co.jp"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    電話番号 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="03-1234-5678"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="video_purpose" className="block text-sm font-medium text-gray-700 mb-2">
                  動画の用途 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="video_purpose"
                  name="video_purpose"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="例: 企業PR、商品紹介、採用動画など"
                />
              </div>

              <div>
                <label htmlFor="video_image" className="block text-sm font-medium text-gray-700 mb-2">
                  動画のイメージ(500文字以内)
                </label>
                <textarea
                  id="video_image"
                  name="video_image"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="どのような動画を制作したいか、イメージをお聞かせください"
                ></textarea>
              </div>

              <div>
                <label htmlFor="other" className="block text-sm font-medium text-gray-700 mb-2">
                  その他(500文字以内)
                </label>
                <textarea
                  id="other"
                  name="other"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-400 focus:border-transparent text-sm"
                  placeholder="ご質問やご要望などがあればお聞かせください"
                ></textarea>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  送信する
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/9b5cb2be715dfa48e9b481baf6e0e4bb/79cc7bd70f6d7cb5ba573af22dbfb8e5.png"
              alt="AI AM Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              AIが、あなたのマーケティングチームになる。<br />
              次世代AIマーケティングソリューション
            </p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <p className="text-gray-400">
              株式会社アンドロード<br />
              Email: otoiawase@ml.androad.co.jp
            </p>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 mt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          <p>Copyright © 2025 ANDROAD Co., Ltd. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
